// designer_components/constants.js

export const CUSTOM_TYPES = [
  { name: "que_key", type: "Integer", isAttr: true },
  { name: "que_topic", type: "String", isAttr: true },
  { name: "bot_act_as", type: "String", isAttr: true },
  { name: "que_category", type: "String", isAttr: true },
  { name: "is_action_trigger", type: "Boolean", isAttr: true },
  { name: "expects_yes_no", type: "Boolean", isAttr: true },
  { name: "create_usr", type: "String", isAttr: true },
  { name: "entry_status", type: "Boolean", isAttr: true },
  { name: "bot_process_flg", type: "Boolean", isAttr: true },
  { name: "default_node_flag", type: "Boolean", isAttr: true },
  { name: "node_key_words", type: "String", isAttr: true },
  { name: "ans_desc", type: "String", isAttr: true },
  { name: "ans_in_convo_id", type: "Boolean", isAttr: true },
  { name: "convo_id", type: "Integer", isAttr: true },
  { name: "comments", type: "String", isAttr: true },
  { name: "is_ussd_prompt", type: "Boolean", isAttr: true },
  { name: "stems_logic_in_num", type: "Boolean", isAttr: true },
  { name: "culture", type: "String", isAttr: true },
  { name: "enforces_match", type: "Boolean", isAttr: true },
];

export const FORM_FIELDS = [
  {
    name: "form_phrase",
    label: "Form Phrase",
    placeholder: "E.g. mobile app opinion survey",
    type: "text",
  },
  {
    name: "convo_name",
    label: "Conversation Name",
    placeholder: "E.g. Customer Opinion on our Mobile App",
    type: "text",
  },
  {
    name: "convo_description",
    label: "Description",
    placeholder: "E.g. This is a survey to our customer...",
    type: "textarea",
  },
  {
    name: "max_allowed_attempts",
    label: "Max Allowed Attempts",
    placeholder: "E.g. 1",
    type: "number",
  },
  {
    name: "allows_retry_after_days",
    label: "Retry After Days",
    placeholder: "E.g. 9999",
    type: "number",
  },
];

export const BOOLEAN_FIELDS = [
  { name: "informs_sender_if_maxed", label: "Inform Sender When Max Attempts Reached" },
  { name: "stems_logic_in_num", label: "Stems Logic in Numbers" },
  { name: "skip_consent_prompt", label: "Skip Consent Prompt" },
];

export const FORM_TYPE_OPTIONS = [
  "Survey",
  "Questionnaire",
  "Feedback Form",
  "Support Questions",
  "Verification",
];

export const MANDATORY_ATTRIBUTES = ["ans_desc", "node_key_words"];

export const NODE_FIELDS = [
  {
    name: "node_key_words",
    label: "Node Keywords",
    type: "textarea",
    required: true,
    rows: 2,
    maxLength: 400,
  },
  {
    name: "ans_desc",
    label: "Answer Description",
    type: "textarea",
    required: true,
    rows: 3,
    maxLength: 1000,
  },
  {
    name: "que_topic",
    label: "Question Topic",
    type: "select",
    required: true,
    options: ["", "topic1", "topic2", "topic3"],
    defaultLabel: "Select Topic",
  },
  {
    name: "bot_act_as",
    label: "Bot Act As",
    type: "select",
    required: true,
    options: ["", "assistant", "advisor", "expert"],
    defaultLabel: "Select Role",
  },
  {
    name: "que_category",
    label: "Question Category",
    type: "select",
    required: true,
    options: ["", "general", "technical", "specific"],
    defaultLabel: "Select Category",
  },
  {
    name: "culture",
    label: "Culture",
    type: "select",
    required: true,
    options: ["", "global", "regional", "local"],
    defaultLabel: "Select Culture",
  },
  {
    name: "enforces_match",
    label: "Enforces Match",
    type: "checkbox",
  },
  {
    name: "comments",
    label: "Comments",
    type: "textarea",
    rows: 2,
    maxLength: 300,
  },
];

export const INITIAL_FORM_STATE = {
  form_phrase: "",
  convo_name: "",
  convo_description: "",
  form_type: "",
  max_allowed_attempts: 1,
  informs_sender_if_maxed: true,
  allows_retry_after_days: 9999,
  stems_logic_in_num: false,
  skip_consent_prompt: false,
  node_key_words: "",
  ans_desc: "",
  que_topic: "",
  bot_act_as: "",
  que_category: "",
  culture: "",
  enforces_match: false,
  comments: "",
  node_number: "",
  nodeDetails: "",
};